import { type ReactNode } from "react";
import { LazyFlockGlobeCanvas } from "./LazyFlockGlobeCanvas";

interface LoginGlobeBackdropProps {
  children: ReactNode;
}

export function LoginGlobeBackdrop({ children }: LoginGlobeBackdropProps) {
  return (
    <div
      className="relative isolate mx-auto flex w-full max-w-[50rem] items-center justify-center overflow-clip py-4 sm:py-8 lg:min-h-[720px]"
      data-testid="auth-globe-backdrop"
    >
      <div className="relative flex min-h-[540px] w-full items-center justify-center overflow-clip sm:min-h-[620px] lg:min-h-[700px]">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 z-0 bg-[radial-gradient(circle_at_50%_48%,rgb(var(--starling-glass-glow)/0.18),transparent_62%)]"
        />
        <div
          aria-hidden="true"
          className="pointer-events-none absolute left-1/2 top-1/2 z-0 -translate-x-1/2 -translate-y-[52%] scale-[0.76] opacity-55 sm:scale-90 lg:scale-100 lg:opacity-80 xl:scale-110"
        >
          <LazyFlockGlobeCanvas
            size={740}
            radius={300}
            tone="teal"
            particleCount={820}
          />
        </div>

        <div className="relative z-10 flex w-full justify-center">
          {children}
        </div>
      </div>
    </div>
  );
}
